import store from '../store'
import {
  getMethod, postMethod
} from "@/api/signUp/signUp";
export default function getInfo() {
  return new Promise((resolve, reject) => {
    if (sessionStorage.getItem("menhuTit")&&window.location.href.split("?")[1]==sessionStorage.getItem("xzcode")) {
      resolve(sessionStorage.getItem("menhuTit"));
    } else if (window.location.href.split("?")[1]) {
      let obj = {
        mhssqy: window.location.href.split("?")[1]
          ? window.location.href.split("?")[1].split("=")[1]
          : this.$store.state.user.xzcode
      };
      postMethod("/CqjyMhgl/selectCqjyMhglByXzqh", obj).then(res => {
        if (res.data.success) {
          resolve(res.data.msg.mhname);
          sessionStorage.setItem("infoData", JSON.stringify(res.data.msg));
          let mhssqy = res.data.msg.mhssqy;
          let code = mhssqy.split(",")[mhssqy.split(",").length - 1];
          store.commit("SET_XZCODE1", code);
          window.sessionStorage.setItem("xzcode", code);
          let data = res.data.msg;
          sessionStorage.setItem("menhuTit", data.mhname);
          sessionStorage.setItem("menhuId", data.id);
          let link = document.querySelector("link[rel*='icon']") || document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = process.env.DOWNLOAD_URL + data.mhicon;
          document.getElementsByTagName("head")[0].appendChild(link);
        }
      })
    } else {
      getMethod("/CqjyMhgl/selectByZz").then(res => {
        if (res.data.success) {
          resolve(res.data.msg[0].mhname);
          sessionStorage.setItem("infoData", JSON.stringify(res.data.msg[0]));
          let mhssqy = res.data.msg[0].mhssqy;
          let code = mhssqy.split(",")[mhssqy.split(",").length - 1];
          store.commit("SET_XZCODE1", code);
          window.sessionStorage.setItem("xzcode", code);
          let data = res.data.msg[0];
          sessionStorage.setItem("menhuTit", data.mhname);
          sessionStorage.setItem("menhuId", data.id);
          let link = document.querySelector("link[rel*='icon']") || document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = process.env.DOWNLOAD_URL + data.mhicon;
          document.getElementsByTagName("head")[0].appendChild(link);
        } else {
          reject()
        }
      });
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/getInfo.js